export enum EScratcherType {
    PHYSICAL = "physical",
    DIGITAL = "digital",
}
